<template>
  <Purchase :product="product" :startPurchase="pay" v-if="product">
    <template v-slot:header>
      <PurchasePersonDetails
        :product="product"
        :person="profile"
      />
    </template>
    <template v-slot:default>
      <div class="label-group">
        <span class="label-heading">{{ $t('purchase.sharingReport') }}</span>
      </div>
      <ConfirmationForm
        type="email"
        email
        name="recipientEmail"
        scope="purchase"
        :withPlaceholder="false"
        required
        v-model.trim="details.recipientEmail"
      />
      <div v-if="$t('purchase.sharingReportAlert1')" class="alert alert-default mt-5" role="alert">
        {{ $t('purchase.sharingReportAlert1') }}
      </div>
      <hr class="divider">
    </template>
  </Purchase>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Purchase from './Purchase';
import ConfirmationForm from './ConfirmationForm';
import PurchasePersonDetails from './PurchasePersonDetails';

export default {
  props: ['product', 'productToBuy'],
  components: {
    Purchase,
    ConfirmationForm,
    PurchasePersonDetails,
  },
  data: () => ({
    details: {
      recipientEmail: '',
    },
  }),
  computed: {
    ...mapState('session', ['profile']),
  },
  methods: {
    ...mapActions('purchase', ['buyMyPaymentDefaults']),

    pay(details) {
      const params = {
        ...details,
        ...this.details,
      };

      return this.buyMyPaymentDefaults(params);
    },
  },
};
</script>
